import { AccountObjectFacade } from "../account-object/account-object.facade";
import { SyncUpItem } from "./sync-up-item.model";
import { SyncUpItemStoreFacade } from "./sync-up-item.store-facade";

export class SyncUpItemFacade extends AccountObjectFacade<SyncUpItem, any, SyncUpItemStoreFacade> {

}



// WEBPACK FOOTER //
// ./src/vas/business-objects/sync-up-item/sync-up-item.facade.ts